import { z } from 'zod';
/** `contents.type` discriminator (ADR-0005); reels are type REEL (Q-13). */
export const CONTENT_TYPES = ['VIDEO', 'REEL', 'ARTICLE', 'GALLERY'];
export const ContentTypeSchema = z.enum(CONTENT_TYPES);
/** `contents.category`; STADIUM drives the Stadium gallery (M-05). */
export const CONTENT_CATEGORIES = ['DEFAULT', 'STADIUM'];
export const ContentCategorySchema = z.enum(CONTENT_CATEGORIES);
/** `contents.status`. */
export const CONTENT_STATUSES = ['DRAFT', 'PUBLISHED', 'ARCHIVED'];
export const ContentStatusSchema = z.enum(CONTENT_STATUSES);
/** `events.status`; Today/Upcoming/Previous is computed at query time (ADR-0013). */
export const EVENT_STATUSES = ['DRAFT', 'PUBLISHED', 'CANCELLED'];
export const EventStatusSchema = z.enum(EVENT_STATUSES);
/** `GET /v1/app/events?when=` filter and the computed `when` field (05-api-specification.md). */
export const EVENT_WHEN_FILTERS = ['ALL', 'TODAY', 'UPCOMING', 'PREVIOUS'];
export const EventWhenFilterSchema = z.enum(EVENT_WHEN_FILTERS);
/** `likes.targetType`, `share_events.targetType`. */
export const ENGAGEMENT_TARGET_TYPES = ['CONTENT', 'EVENT'];
export const EngagementTargetTypeSchema = z.enum(ENGAGEMENT_TARGET_TYPES);
/** `likes.targetKind`; used by Favorites filters. */
export const ENGAGEMENT_TARGET_KINDS = ['VIDEO', 'REEL', 'ARTICLE', 'GALLERY', 'EVENT'];
export const EngagementTargetKindSchema = z.enum(ENGAGEMENT_TARGET_KINDS);
//# sourceMappingURL=content.js.map